module.exports = __webpack_public_path__ + "img/price-match-promise.3c36c5f.svg";